import {ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {NotificationsService} from '../notifications.service';
import {Notifications} from '../notifications.enum';
import {UserService} from '../../../shared/user.service';

@Component({
	selector: 'tt-days-off-requests-notification',
	templateUrl: './days-off-requests.component.html',
	styleUrls: ['./days-off-requests.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class DaysOffRequestsNotificationComponent implements OnInit {

	approvedDaysOffRequests: any[] = [];

	constructor(
		private notificationsService: NotificationsService,
		private userService: UserService,
		private ref: ChangeDetectorRef
	) {
	}

	ngOnInit(): void {
		this.updateDaysOffRequests();

		this.notificationsService.dayOffApproved$
			.subscribe(() => this.updateDaysOffRequests());
	}

	updateDaysOffRequests(): void {
		this.notificationsService.getApprovedDaysOff()
			.map((ranges: any[]) => {
				return ranges.sort((a: any, b: any) => a.dates[0].date - b.dates[0].date);
			})
			.subscribe((ranges: any[]) => {
				this.approvedDaysOffRequests = ranges;
				this.ref.detectChanges();
			});
	}

	public isCurrentUser(id: number): boolean {
		return this.userService.user.id === id;
	}

	isVisible(): boolean {
		return this.notificationsService.isNotificationAvailable(Notifications.APPROVED_DAYS_OFF)
			&& this.dataPresent();
	}

	closeNotification(): void {
		this.notificationsService.closeNotification(Notifications.APPROVED_DAYS_OFF);
	}

	isPartialDayOffRange(range: any): boolean {
		return this.notificationsService.isPartialDaysOffRange(range);
	}

	isToday(date: Date): boolean {
		const today: Date = new Date(),
			d: Date = new Date(date);
		return d.getDate() === today.getDate() && d.getMonth() === today.getMonth() && d.getFullYear() === today.getFullYear();
	};

	private dataPresent(): boolean {
		return this.approvedDaysOffRequests && this.approvedDaysOffRequests.length !== 0;
	}

}



// WEBPACK FOOTER //
// ./src/app/my-time/notifications/days-off-requests/days-off-requests.component.ts